<template>
    <footer class="footer-wrap h-h91 flex justify-center items-center">
        <ul class="footer-menu flex justify-center items-center">
            <li class="rp">
                <a class="font-medium text-xs text-dark_gray px-spc6 py-spc25" href="#">
                    Tesla &copy; 2020
                </a>
            </li>
            <li class="rp">
                <a class="font-medium text-xs text-dark_gray px-spc6 py-spc25" href="#">
                    Privacy &amp; Legal
                </a>
            </li>
            <li class="rp-none">
                <a class="font-medium text-xs text-dark_gray px-spc6 py-spc25" href="#">
                    Contact
                </a>
            </li>
            <li class="rp-none">
                <a class="font-medium text-xs text-dark_gray px-spc6 py-spc25" href="#">
                    Careers
                </a>
            </li>
            <li class="rp-none">
                <a class="font-medium text-xs text-dark_gray px-spc6 py-spc25" href="#">
                    Get Newsletter
                </a>
            </li>
            <li class="rp-none">
                <a class="font-medium text-xs text-dark_gray px-spc6 py-spc25" href="#">
                    Forums
                </a>
            </li>
            <li class="rp-none">
                <a class="font-medium text-xs text-dark_gray px-spc6 py-spc25" href="#">
                    Locations
                </a>
            </li>
        </ul>
    </footer>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>

</style>